import styles from './styles/styles.module.scss';

export default function MiddleDot() {
  return <span className={styles.dot}>·</span>;
}
